import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { StorageService } from "../../services/storage.service";
import { HttpClient } from "@angular/common/http";
import { IsPointV2, AppLogo2, ClgLogo } from "../../app.config";
import { CommonService } from "src/app/services/common.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  login: Response;
  login_message: any;
  login_user_id: any;
  login_role_id: any;
  hide = true;
  showError: any = false;
  appLogo = AppLogo2;
  clgLogo = ClgLogo;
  selectedRole: null;
  RoleChange: any;

  constructor(
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private http: HttpClient,
    private commonService: CommonService,
    private modalService: NgbModal
  ) {
    this.ls.removeAll();
  }
  private ls = new SecureLS({ encodingType: "aes" });
  ngOnInit() {
    if (this.storageService.clearIntval) {
      clearInterval(this.storageService.clearIntval);
    }
    this.loginForm = this.fb.group({
      login_id: ["", [Validators.required]],
      password: ["", Validators.required],
    });
  }

  get f() {
    return this.loginForm.controls;
  }
  async changeRoles(selectedRole) {
    if (selectedRole) {
      this.commonService.changeRoleService(selectedRole);
    } else {
      this.showError = true;
    }
  }

  async loginUser(form: FormGroup, contentlist) {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.spinner.show();
    let inputData = {
      username: form.value.login_id,
      password: form.value.password,
    };
    this.login = await this.globalService.create(
      "user/login",
      inputData,
      IsPointV2
    );
    if (this.login) {
      let compData = this.login["content"];
      if (this.login["status"] === 200) {
        this.ls.set("is_multiple_role", compData.is_multiple_role);
        if (compData.hasOwnProperty("login_otp") && compData.login_otp == 0) {
          this.ls.set("user_id", compData?.user_info?.id);
          if (compData?.user_info?.userByRole?.length == 1) {
            if (!this.ls.get("role")) {
              this.ls.set("role", compData.user_info.userByRole[0].id);
            }
          } else {
            if (!this.ls.get("role")) {
              this.ls.set("role", compData?.user_info?.role_id);
            }
          }
          if (
            compData?.user_info?.userByRole?.length === 1 ||
            compData?.user_info?.userByRole?.length === 0
          ) {
            this.commonService.setLSDataFromResponse(compData);
          } else {
            this.selectedRole = null;
            this.modalService.open(contentlist, { centered: true, size: "md" });
            this.RoleChange = compData.user_info.userByRole;
          }
        } else {
          this.login_message = this.login["message"];
          this.ls.set("user_id", compData.user_id);
          if (compData?.userByRole?.length === 1) {
            this.ls.set("role", compData.userByRole[0].userRole.role_id);
          } else {
            this.ls.set("role", "");
          }
          this.router.navigate(["/otp-verify"]);
        }

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    }
  }
}
